import to from 'await-to-js';
import axios from 'axios';
import { mapState, mapGetters } from 'vuex';

import featureFlagsMixin from './featureFlags';

import {
  enableMarginInitialisation,
  marginInitialisationSearchFunction,
  marginInitialisationRangeMin,
  marginInitialisationRangeMax,
  marginInitialisationSearchPrecision,
} from '@enums/feature-flags';

const mixin = {
  mixins: [featureFlagsMixin],
  data: () => {
    return {
      runningMarginInitialisation: false,
    };
  },
  computed: {
    ...mapState('workpackages', ['selectedWorkpackage']),
    ...mapState('clientConfig', ['toggleLogic']),
    ...mapGetters('workpackages', ['isSelectedWorkpackageMaster']),
    marginInitialisationEnabled() {
      return (
        !this.isSelectedWorkpackageMaster && this.isFeatureFlagEnabled(enableMarginInitialisation)
      );
    },
  },
  methods: {
    async runMarginInitialisation(retainMarginSteeringDelta = true) {
      this.runningMarginInitialisation = true;
      const [err] = await to(
        axios.post(
          `/api/inputs/workpackage/${this.selectedWorkpackage._id}/runMarginInitialisation`,
          {
            searchMethod: this.toggleLogic[marginInitialisationSearchFunction],
            rangeMin: this.toggleLogic[marginInitialisationRangeMin],
            rangeMax: this.toggleLogic[marginInitialisationRangeMax],
            searchPrecision: this.toggleLogic[marginInitialisationSearchPrecision],
            retainMarginSteeringDelta,
          }
        )
      );
      if (err) {
        this.runningMarginInitialisation = false;
      }
    },
    async handleRunMarginInitialisationFinished({ payload: workpackageId }) {
      const selectedWorkpackageId = this.selectedWorkpackage._id || workpackageId;
      // Ensure that response matches current workpackageId
      if (workpackageId !== selectedWorkpackageId) {
        return;
      }

      this.runningMarginInitialisation = false;
    },
  },
  async created() {
    if (this.marginInitialisationEnabled) {
      // Check if margin initialisation is currently running
      const [err, res] = await to(
        axios.get(
          `/api/inputs/workpackage/${this.selectedWorkpackage._id}/runMarginInitialisation/status`
        )
      );
      if (err) {
        this.runningMarginInitialisation = false;
        throw new Error(err.message);
      }
      const { data: isMarginInitialisationRunning } = res;
      this.runningMarginInitialisation = isMarginInitialisationRunning;
    }
  },
  mounted() {
    this.$eventBus.$on(
      'runMarginInitialisationFinished',
      this.handleRunMarginInitialisationFinished
    );
  },
  beforeDestroy() {
    this.$eventBus.$off('runMarginInitialisationFinished');
  },
};

export default mixin;
